import { Form, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { utils } from "ethers";
import Address from "../../api/types/address";

interface Props {
  ownAddress: string | Address;
  submit: (receiverAddress: string, oC: boolean) => void;
}

function ReceiverSelection(props: Props) {
  const { t } = useTranslation();
  const [ownChecked, setOwnChecked] = useState(true);
  const [otherReceiverAddress, setOtherReceiverAddress] = useState<string>();

  useEffect(() => {
    props.submit(otherReceiverAddress!, ownChecked);
  }, [otherReceiverAddress]);
  const getOwnAddressLabel = (): JSX.Element => {
    const strAddr =
      props.ownAddress instanceof Address
        ? props.ownAddress.toString()
        : props.ownAddress;
    return (
      <>
        {t("atMyOwnAddress")} (
        <div className={"address"} style={{ display: "inline-block" }}>
          {`${strAddr.substring(0, 5)}...`}
        </div>
        )
      </>
    );
  };

  const checkAddress = (
    ev: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    if (utils.isAddress(ev.target.value)) {
      ev.target.setCustomValidity("");
    } else {
      ev.target.setCustomValidity("invalid");
    }
  };

  return (
    <>
      <Form.Label className={"padding"} style={{ fontSize: "110%" }}>
        {" "}
        {t("whereReceiveSwap")}{" "}
      </Form.Label>
      <Row className="justify-content-center">
        <Form.Group className="mb-3 receiver-address-form">
          <Form.Check
            type="radio"
            id="own-recv-address-check"
            name="receiver-address-choice"
            checked={ownChecked}
            onChange={() => setOwnChecked(true)}
            label={getOwnAddressLabel()}
            className="receiver-check"
            required
          />
          <Form.Check
            type="radio"
            id="other-recv-address-check"
            name="receiver-address-choice"
            checked={!ownChecked}
            onChange={() => setOwnChecked(false)}
            label={t("atADifferentAddress")}
            className="receiver-check"
            required
          />
          {!ownChecked && (
            <Form.Group className="address-input">
              <Form.Control
                id="receiver-address-input"
                type="text"
                required
                placeholder="Receiver Address"
                onChange={(event) => {
                  checkAddress(event);
                  setOtherReceiverAddress(event.target.value);
                }}
              />
              <Form.Control.Feedback type="invalid">
                {t("enterValidEthAddress")}
              </Form.Control.Feedback>
            </Form.Group>
          )}
        </Form.Group>
      </Row>
    </>
  );
}

export default ReceiverSelection;
